import React__default from 'react';
import classNames from 'classnames';
import { Modal, Image, Button, Link } from '@grandvisionhq/common';

const QrCode = ({ className , externalUrl , isOpen , isQrCodeExpired , isQrRefreshLoading , labels , logoSettings , onCancel , qrCodeUrl , refreshQrCode  })=>{
    return /*#__PURE__*/ React__default.createElement(Modal, {
        isOpen: isOpen,
        className: classNames('qr-code-modal', className),
        title: labels.title,
        isOutsideClickEnabled: false
    }, /*#__PURE__*/ React__default.createElement("div", null, logoSettings && /*#__PURE__*/ React__default.createElement("img", {
        src: logoSettings.url,
        alt: logoSettings.alt
    })), /*#__PURE__*/ React__default.createElement("div", {
        className: "qr-code-modal__qr-code"
    }, /*#__PURE__*/ React__default.createElement(Image, {
        alt: "qr code",
        url: qrCodeUrl,
        cover: true,
        className: classNames({
            'qr-code-modal__is-expired': isQrCodeExpired
        })
    }, isQrCodeExpired && /*#__PURE__*/ React__default.createElement(Button, {
        "data-t": "refresh-qr-code",
        icon: "returns-alt",
        caption: labels.refresh,
        className: "qr-code-modal__refresh-button",
        onClick: ()=>refreshQrCode()
        ,
        isLoading: isQrRefreshLoading
    }))), /*#__PURE__*/ React__default.createElement("div", null, /*#__PURE__*/ React__default.createElement(Link, {
        className: "qr-code-modal__redirect-link",
        url: externalUrl,
        openInNewWindow: true
    }, labels.link)), /*#__PURE__*/ React__default.createElement("p", {
        className: "qr-code-modal__description"
    }, labels.description), /*#__PURE__*/ React__default.createElement(Button, {
        caption: labels.cancel,
        variant: "outline",
        "data-t": "qrcode-cancel-payment",
        className: "qr-code-modal__button",
        onClick: onCancel
    }));
};

export { QrCode };
//# sourceMappingURL=QrCode.js.map
